import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings.js";

const Container = tw.div`relative max-w-screen-xl mx-auto px-4 sm:px-8 py-16 md:py-20`;
const Heading = tw(SectionHeading)`mb-4 text-center`;
const Subtext = tw.p`text-center text-sm md:text-base text-secondary-100 max-w-2xl mx-auto mb-10 leading-relaxed`;
const Grid = styled.div`
  ${tw`flex flex-wrap -mx-3`}
  ${(props) => props.$centered && tw`justify-center`}
`;

const Card = styled.div`
  ${tw`px-3 mb-6 flex flex-col items-center`}
  ${(props) => (props.$centered ? tw`w-auto` : tw`w-1/2 md:w-1/3 lg:w-1/4`)}
`;
const PhoneFrame = styled.div`
  ${tw`rounded-2xl overflow-hidden shadow-lg w-full`}
  max-width: 200px;
`;
const Image = styled.img`
  ${tw`w-full h-auto block`}
`;
const Caption = tw.p`mt-3 text-xs md:text-sm font-medium text-secondary-100 text-center px-1`;

const BannerCard = styled.div`
  ${tw`mb-8 last:mb-0 rounded-lg overflow-hidden shadow-lg bg-gray-100`}
`;
const BannerImage = styled.img`
  ${tw`w-full h-auto object-contain block`}
`;

export default ({
  heading = "Screenshots",
  description,
  screenshots = [],
  variant = "phone",
  centered = false,
}) => {
  if (!screenshots.length) return null;

  if (variant === "banner") {
    return (
      <Container>
        <Heading>{heading}</Heading>
        <div>
          {screenshots.map((shot, index) => (
            <BannerCard key={index}>
              <BannerImage src={shot.src} alt={shot.alt || ""} />
              {shot.caption && <Caption>{shot.caption}</Caption>}
            </BannerCard>
          ))}
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <Heading>{heading}</Heading>
      {description && <Subtext>{description}</Subtext>}
      <Grid $centered={centered}>
        {screenshots.map((shot, index) => (
          <Card key={index} $centered={centered}>
            <PhoneFrame>
              <Image src={shot.src} alt={shot.alt || ""} />
            </PhoneFrame>
            {shot.caption && <Caption>{shot.caption}</Caption>}
          </Card>
        ))}
      </Grid>
    </Container>
  );
};
